export const getApiErrorInfo = (error, fallbackMessage = "Ocurrió un error inesperado.") => {
  const data = error?.response?.data || {};
  const status = error?.response?.status || null;
  const errorId = data?.error_id || null;
  const blockedCalendars = Array.isArray(data?.blocked_calendars) ? data.blocked_calendars : [];
  const needsConfirmation = Boolean(data?.needs_confirmation);
  const implicatedCalendars = Array.isArray(data?.implicated_calendars) ? data.implicated_calendars : [];

  const rawMessage =
    data?.message ||
    data?.error ||
    fallbackMessage;

  return {
    status,
    data,
    errorId,
    blockedCalendars,
    needsConfirmation,
    implicatedCalendars,
    message: errorId ? `${rawMessage} Ref: ${errorId}` : rawMessage,
  };
};

export const logApiError = (context, error, fallbackMessage) => {
  const info = getApiErrorInfo(error, fallbackMessage);
  console.error(`[${context}]`, {
    status: info.status,
    errorId: info.errorId,
    data: info.data,
    error,
  });
  return info;
};
